import { createContext } from "react";

type OverallGoalAssessmentQuestionDescriptionContextType = {
  averageScoreOfIndividualGoalBasedQuestions?: string;
  scale?: number;
};

export const OverallGoalAssessmentQuestionDescriptionContext =
  createContext<OverallGoalAssessmentQuestionDescriptionContextType>({});
